export const initialCurrency = [
  {
    id: 1,
    name: 'Euro',
    code: 'EUR',
    symbol: '€',
  },
  {
    id: 3,
    name: 'US Dollar',
    code: 'USD',
    symbol: '$',
  },
  {
    id: 9,
    name: 'Israeli New Sheqel',
    code: 'ILS',
    symbol: '₪',
  },
];

export const getTicketingTypeFromOrderedTicket = (ticketingOrderedTicket: any) => {
  switch (ticketingOrderedTicket.ticketType) {
    case 'gameTour':
      return 'ticketingGameTour';
    case 'guidedTour':
      return 'ticketingGuidedTour';
    // 'tourByYourself'
    default:
      return 'ticketingToursByYourself';
  }
};
